// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"2710e892","284":"31a47a5d","322":"7c5ed455","375":"9eb87aaa","470":"4589d011","628":"36e5100a","718":"ebafc6ad","738":"6a9d5657","804":"5dabf16d","937":"b9033cdc"}[chunkId] + ".chunk.js";
};